<!--
 * @Author: wuyanfeiying
 * @LastEditors: wuyanfeiying
 * @Description: 根据一维柱状图，作为起点，生成的其它曲线的图表
-->
<template>
    <div>
        <div id="chart-container" ref="chartContainer"  :style="{height: '400px', width: '100%'}"></div>
    </div>
  </template>

<script>
import * as echarts from 'echarts'
import Decimal from 'decimal.js'

export default {
  name: 'FactorEcharts',

  props: {
    options: {
      type: Object,
      default: () => ({})
    },
    currentRadio: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      chartInstance: null
    }
  },

  created () {
    this.chartInstance = null
  },

  mounted () {
    this.initEchart()
    window.addEventListener('resize', this.handleResize)
  },

  methods: {
    initEchart () {
      // 创建图表实例
      this.chartInstance = echarts.init(this.$refs.chartContainer)

      // 设置图表配置项和数据
      const option = this.generateOption()
      this.chartInstance.setOption(option)
    },

    // echart 配置项
    generateOption () {
      const { title, saveImgTitle, xAxisData, yAxisDataTitle, seriesData, decimalPlaces, mulNum, grid, legend, tooltip, toolbox, xAxis } = this.options

      // 图例哪些需要展示
      let legendSelected = {}
      seriesData.forEach(item => {
        legendSelected[item.name] = item.legendSelected
      })
      // 图例顺序
      const sortedArr = seriesData.slice().sort((a, b) => b.legendIndex - a.legendIndex)
      const legendData = sortedArr.map(item => item.name)

      // 用于存储每年最早的时间段
      let earliestDates = []
      // 遍历排序后的数组，筛选出每年最早的时间段（也就是每一年的最早交易日）
      let currentYear = null
      xAxisData.forEach(date => {
        const year = Math.floor(date / 10000)
        if (year !== currentYear) {
          earliestDates.push(`${date}`)
          currentYear = year
        }
      })

      // 数据值精度，默认两位
      const _decimalPlaces = decimalPlaces || 2
      // 数据值乘以多少，默认保持原始数据值
      const _mulNum = mulNum || 1

      return {
        title: {
          text: title
        },
        xAxis: xAxis || {
          type: 'category',
          data: xAxisData,
          boundaryGap: false, // 类目轴中 boundaryGap 可以配置为 true 和 false。默认为 true，这时候刻度只是作为分隔线，标签和数据点都会在两个刻度之间的带(band)中间。
          splitLine: {
            show: true,
            interval: (index, value) => {
              return xAxisData.includes(value)
            }
          }
        },
        yAxis: {
          type: 'value',
          name: yAxisDataTitle,
          min: 'dataMin', // 最小值设为数据的最小值
          max: 'dataMax' // 最大值设为数据的最大值
        },
        series: seriesData.map(item => ({
          type: item.type, // 数据项的类型
          data: item.data.map(v => {
            if (v != null) {
              return new Decimal(v).mul(_mulNum).toNumber().toFixed(_decimalPlaces)
            } else {
              return ''
            }
          }), // 具体的数据值
          itemStyle: item.itemStyle, // 用于设置数据项的样式
          name: item.name, // 数据项的名称
          areaStyle: item.areaStyle || null, // 用于设置线图中折线下方区域的样式
          z: item.z || null // 用于设置数据项的层级关系，即绘制顺序。z 值越大，数据项越靠前绘制，覆盖在其他数据项之上。
        })),
        dataZoom: [],
        tooltip: tooltip || {
          trigger: 'axis', // 表示当鼠标悬停在坐标轴上时触发显示提示框
          // position: pt => [pt[0], '10%'],
          feature: {
            restore: {
              show: true
            }
          },
          formatter: (params) => {
            let tooltipContent = `<div>${params[0].name}</div></div></div><div style="text-align: left;">` // 设置内容左对齐
            // 根据 params 中的数据自定义提示框的内容
            params.forEach((item) => {
              tooltipContent += item.marker + ' ' + item.seriesName + ': ' + item.value + '<br>'
            })
            tooltipContent += '</div>'
            return tooltipContent
          }
        },
        toolbox: toolbox || {
          feature: {
            dataZoom: {
              yAxisIndex: 'none',
              excludeComponents: ['toolbox', 'dataZoom']
            },
            saveAsImage: {
              name: saveImgTitle
            }
          }
        },
        legend: legend || {
          left: 'center',
          textStyle: {
            fontSize: 16
          },
          selected: legendSelected,
          data: legendData
        },
        grid: grid || [
          {
            top: '30px',
            right: '5%',
            left: '12%',
            bottom: '20%'
          }
        ]
      }
    },

    drawChart () {
    // 获取容器元素
      const chartContainer = this.$refs['chart-container']

      // 初始化echarts实例
      this.chartInstance = echarts.init(chartContainer)

      // 设置图表配置项和数据
      const option = this.echartOption
      console.log('🚀 ~ file: FactorEcharts.vue:118 ~ drawChart ~ option:', option)

      // 使用配置项和数据绘制图表
      this.chartInstance.setOption(option)

      // 监听浏览器窗口尺寸变化事件
      window.addEventListener('resize', () => {
        // 调用图表的 resize 方法
        this.chartInstance.resize()
      })
    },

    handleResize () {
      this.chartInstance.resize()
    },

    // 导出图片
    exportImage () {
      const src = this.chartInstance.getDataURL({
        pixelRatio: 2,
        backgroundColor: '#fff'
      })
      const a = document.createElement('a')
      a.href = src
      a.download = this.options.saveImgTitle
      a.click()
    }
  },

  watch: {
    options: {
      deep: true,
      handler () {
        this.initEchart()
      }
    }
  },

  destroyed () {
    window.removeEventListener('resize', this.handleResize)
    this.chartInstance = null
  }
}
</script>



// WEBPACK FOOTER //
// src/components/allPage/FactorEchart.vue